import { Modal } from '@/components/Modal'

import { modalId } from '../hooks/useController'
import { Content } from './Content'

type Props = {
  driverId: string
}

export function Root(props: Props) {
  return (
    <Modal modalId={modalId}>
      <Content driverId={props.driverId} />
    </Modal>
  )
}
